import { environmentVariables } from "./ReadContent";

const colors = [
  { backgroundColor: '#ffe4e4', color: '#cf3903' },
  { backgroundColor: '#e7ffdc', color: '#097360' },
  { backgroundColor: '#cde1ff', color: '#4e0aa2' },
  { backgroundColor: '#ffdaf9', color: '#690c58' },
];

const getColorForCategory = (categoryIndex) => colors[categoryIndex % colors.length];

const CategoryCard = () => {
  const data = environmentVariables.aboutCategory;

  return (
    <div className="flex select-none max-w-lg text-[0.65rem] md:text-sm lg:text-[0.9rem] xl:text-base items-center font-semibold justify-between w-[80%] sm:w-[75%] md:w-[70%] lg:w-[65%] xl:w-[60%] mx-auto mt-6 mb-8">
      {data.map((category, index) => {
        const style = getColorForCategory(index);
        return (
          <div key={index} className="rounded-[0.89rem] px-2 md:px-3 md:py-1" style={{ backgroundColor: style.backgroundColor, color: style.color }}>
            {category}
          </div>
        );
      })}
    </div>
  );
};

export default CategoryCard;
